import React from 'react';
import ScaledImg from '../ScaledImg';
import ingredientsImg from './img/ingredients.png';
import './IngredientsSection.css'; // Import the CSS file

export type Ingredients = {
  name: string;
  subingredients: { name: string }[];
}[];

interface IngredientsSectionProps {
  ingredients: Ingredients;
  setIngredients: (ingredients: Ingredients) => void;
}

const IngredientsSection: React.FC<IngredientsSectionProps> = ({ ingredients, setIngredients }) => {
  const handleIngredientChange = (index: number, value: string) => {
    const newIngredients = [...ingredients];
    newIngredients[index].name = value;
    setIngredients(newIngredients);
  };

  const handleSubingredientChange = (ingredientIndex: number, subingredientIndex: number, value: string) => {
    const newIngredients = [...ingredients];
    newIngredients[ingredientIndex].subingredients[subingredientIndex].name = value;
    setIngredients(newIngredients);
  };

  const addIngredient = () => {
    setIngredients([...ingredients, { name: '', subingredients: [{ name: '' }] }]);
  };

  const removeIngredient = (index: number) => {
    const newIngredients = ingredients.filter((_, i) => i !== index);
    setIngredients(newIngredients);
  };

  const addSubingredient = (ingredientIndex: number) => {
    const newIngredients = [...ingredients];
    newIngredients[ingredientIndex].subingredients.push({ name: '' });
    setIngredients(newIngredients);
  };

  const removeSubingredient = (ingredientIndex: number, subingredientIndex: number) => {
    const newIngredients = [...ingredients];
    newIngredients[ingredientIndex].subingredients = newIngredients[ingredientIndex].subingredients.filter((_, i) => i !== subingredientIndex);
    setIngredients(newIngredients);
  };

  return (
    <div>
      <h2>Ingredients</h2>
      <ScaledImg src={ingredientsImg} />
      {ingredients.map((ingredient, ingredientIndex) => (
        <div key={ingredientIndex} className="ingredient">
          <div className="ingredient-header">
            <label htmlFor={`ingredient-${ingredientIndex}`}>Ingredient {ingredientIndex + 1} *</label>
            <input
              type="text"
              id={`ingredient-${ingredientIndex}`}
              value={ingredient.name}
              onChange={(e) => handleIngredientChange(ingredientIndex, e.target.value)}
              required
            />
            <button type="button" onClick={() => removeIngredient(ingredientIndex)}>Remove Ingredient</button>
          </div>
          {ingredient.subingredients.map((subingredient, subingredientIndex) => (
            <div key={subingredientIndex} className="subingredient">
              <label htmlFor={`subingredient-${ingredientIndex}-${subingredientIndex}`}>
                Subingredient {ingredientIndex + 1}.{subingredientIndex + 1}
              </label>
              <input
                type="text"
                id={`subingredient-${ingredientIndex}-${subingredientIndex}`}
                value={subingredient.name}
                onChange={(e) => handleSubingredientChange(ingredientIndex, subingredientIndex, e.target.value)}
                required
              />
              <button
                type="button"
                onClick={() => removeSubingredient(ingredientIndex, subingredientIndex)}
              >
                Remove Subingredient
              </button>
            </div>
          ))}
          <button type="button" onClick={() => addSubingredient(ingredientIndex)}>Add Subingredient</button>
        </div>
      ))}
      <button type="button" onClick={addIngredient}>Add Ingredient</button>
    </div>
  );
};

export default IngredientsSection;
